import React, { Component } from 'react';
import PropTypes from "prop-types";

import CardFooter from './CardFooter';
import LinkToNoveList from 'react/views/generic/LinkToNoveList';
import FindIt from '../views/generic/FindIt';

class DetailsFooter extends Component {
    renderLinktoNoveList() {
        const {linkToNovelist, pLinkFeatureType, pLinkDestId, activeTitleUi} = {...this.props};
        return(
            linkToNovelist && <LinkToNoveList
                href={linkToNovelist}
                featureType={pLinkFeatureType}
                destId={pLinkDestId}
                srcId={activeTitleUi}
                />
        );
    }

    renderFindIt() {
        const {catalogLink, featureType, uniqueId, activeTitleUi} = {...this.props};
        return catalogLink && <FindIt catalogLink={catalogLink} featureType={featureType} srcId={uniqueId} destId={activeTitleUi} />;
    }

    render() {
        return <CardFooter leftContent={this.renderLinktoNoveList()} rightContent={this.renderFindIt()}/>;
    }
}

DetailsFooter.propTypes = {
    linkToNovelist: PropTypes.string,
    featureType: PropTypes.object,
    catalogLink: PropTypes.object,
    uniqueId: PropTypes.string,
    pLinkFeatureType: PropTypes.object,
    pLinkDestId: PropTypes.string,
    activeTitleUi: PropTypes.string
};

export default DetailsFooter;



// WEBPACK FOOTER //
// ./src/react/card/DetailsFooter.jsx